















import { Component, Prop, Vue } from 'vue-property-decorator';
import GTopicSubject from '@/components/GTopicSubject.vue';
import { GEnum } from '@/constants/enum.defination';
import { EChartService } from '@/service/echart/echart.service';
import { SelfGiftRaderEchartService } from '@/service/echart/self-gift-rader.echart.service';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentCompetencySummary } from '@/models/student/student-competency-summary';
import { Student } from '@/models/student/student';
import GCompetencyHeader from '@/components/GCompetencyHeader.vue';

@Component({
  name: 'GStudentRecordCompetencySummary',
  components: { GCompetencyHeader, GTopicSubject },
  computed: {},
  methods: {},
})
export default class GStudentRecordCompetencySummary extends Vue {
  chartOptionsCognitive: any = {};
  chartOptionsIndividual: any = {};
  chartOptionsInterpersonal: any = {};
  chartOptionsCommunity: any = {};
  raderCharts: any = {};

  @Prop() studentID: number;

  async mounted() {
    await studentModule.fetchStudentCompetencySummary(this.studentID);
    this.initCompetencySummaryChart();
    this.raderCharts = [
      {
        type: GEnum.CompetencyType.Cognitive,
        label: this.$t('COGNITIVE').toString(),
        options: this.chartOptionsCognitive,
      },
      {
        type: GEnum.CompetencyType.Self,
        label: this.$t('SELF').toString(),
        options: this.chartOptionsIndividual,
      },
      {
        type: GEnum.CompetencyType.Gift,
        label: this.$t('INTERPERSONAL').toString(),
        options: this.chartOptionsInterpersonal,
      },
      {
        type: GEnum.CompetencyType.Community,
        label: this.$t('COMMUNITY').toString(),
        options: this.chartOptionsCommunity,
      },
    ];
  }

  get student(): Student {
    return studentModule.student;
  }

  get studentCompetencySummary(): StudentCompetencySummary {
    return studentModule.studentCompetencySummary;
  }

  initCompetencySummaryChart() {
    this.chartOptionsCognitive = this.createOptions(GEnum.CompetencyType.Cognitive);
    this.chartOptionsIndividual = this.createOptions(GEnum.CompetencyType.Self);
    this.chartOptionsInterpersonal = this.createOptions(GEnum.CompetencyType.Gift);
    this.chartOptionsCommunity = this.createOptions(GEnum.CompetencyType.Community);
  }

  private createOptions(type: GEnum.CompetencyType) {
    const competencyLabels: string[] = this.studentCompetencySummary.competencyNamesByType(type);
    const giftScoreValues: number[] = this.studentCompetencySummary.giftScoresByType(type);
    const selfEvalScoreValues: number[] = this.studentCompetencySummary.selfScoresByType(type);
    const echartService: EChartService = new SelfGiftRaderEchartService(this.$t('SELF_EVAL').toString(), this.$t('GIFT_SCORE').toString(), competencyLabels, type);

    echartService.addSeries({ selfScores: selfEvalScoreValues, giftScores: giftScoreValues });

    return echartService.options;
  }
}
